import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

const ErrorContainer = ({ error }) => {
  if (!error) return null;

  const alertStyle = {
    marginBottom: 20,
  };

  if (error.type === 'validationError') {
    return (
      <Alert
        style={alertStyle}
        type="error"
        message={error.type}
        description={error.details.map(errorDetail => <span key={errorDetail.message}>{errorDetail.message}</span>)}
        showIcon
      />
    );
  }

  return <Alert style={alertStyle} type="error" message={error.type} showIcon />;
};

ErrorContainer.defaultProps = {
  error: null,
};

ErrorContainer.propTypes = {
  error: PropTypes.object,
};

export default ErrorContainer;



// WEBPACK FOOTER //
// ./src/components/FormErrorContainer.js